import { InputValue } from '@optimus-web/common';

export const isValidSearchTerm = (value: InputValue) => value.toString().trim().length > 0;
